'use client';
import React from 'react';
import { Star } from 'lucide-react';

export const TTOSStatsRibbon: React.FC = () => {
  const stats = [
    {
      value: '10,000+',
      label: 'Businesses Trust TT OS',
    },
    {
      value: '30+',
      label: 'AI Powered Tools',
    },
    {
      value: '500K+',
      label: 'Contents Generated',
    },
    {
      value: '99.9%',
      label: 'Uptime & Security',
    },
    {
      value: '5 Star',
      label: 'User Rating',
      stars: 5,
    },
  ];

  return (
    <section className="py-10 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Dark Navy / Deep Slate Card Banner */}
        <div className="rounded-2xl sm:rounded-3xl bg-[#090D1A] border border-slate-800/80 px-6 py-8 sm:py-10 shadow-2xl relative overflow-hidden">
          
          {/* Subtle Cyber Glow Accents */}
          <div className="absolute top-0 right-1/4 w-72 h-32 bg-indigo-500/10 blur-[80px] rounded-full pointer-events-none" />
          <div className="absolute bottom-0 left-1/4 w-72 h-32 bg-purple-500/10 blur-[80px] rounded-full pointer-events-none" />

          {/* 5 Stats Columns */}
          <div className="grid grid-cols-2 md:grid-cols-5 gap-6 sm:gap-4 text-center divide-y md:divide-y-0 md:divide-x divide-slate-800/80">
            {stats.map((stat, idx) => (
              <div
                key={idx}
                className={`flex flex-col items-center justify-center space-y-1 ${
                  idx > 0 ? 'pt-4 md:pt-0' : ''
                } ${idx === 4 ? 'col-span-2 md:col-span-1' : ''}`}
              >
                <div className="text-2xl sm:text-3xl lg:text-4xl font-black text-white tracking-tight">
                  {stat.value}
                </div>

                {stat.stars && (
                  <div className="flex items-center gap-0.5 text-amber-400 py-0.5">
                    {[...Array(stat.stars)].map((_, s) => (
                      <Star key={s} className="w-3.5 h-3.5 fill-amber-400" />
                    ))}
                  </div>
                )}

                <div className="text-[11px] sm:text-xs text-slate-400 font-medium">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>

        </div>

      </div>
    </section>
  );
};

export default TTOSStatsRibbon;
